module.exports = {
  messages: {
    ARTICLES_ARTICLE_VIEWER_ARIA_LABEL_BUTTON_MORE: 'more',
    ARTICLES_ARTICLE_VIEWER_AUTHOR_LINK_ARIA_LABEL: "Go to {name}'s profile",
    ARTICLES_ARTICLE_VIEWER_COMMENTS_HEADLINE: 'Comments',
    ARTICLES_ARTICLE_VIEWER_CONTENT_FOLLOWER_PLURAL: 'followers',
    ARTICLES_ARTICLE_VIEWER_CONTENT_FOLLOWER_SINGULAR: 'follower',
    ARTICLES_ARTICLE_VIEWER_DELETE_BUTTON: 'Delete',
    ARTICLES_ARTICLE_VIEWER_DELETE_DIALOG_CANCEL_BUTTON: 'Cancel',
    ARTICLES_ARTICLE_VIEWER_DELETE_DIALOG_CONFIRM_BUTTON: 'Delete',
    ARTICLES_ARTICLE_VIEWER_DELETE_DIALOG_CONFIRMATION_DESCRIPTION:
      'Delete this article?',
    ARTICLES_ARTICLE_VIEWER_EDIT_BUTTON: 'Edit',
    ARTICLES_ARTICLE_VIEWER_ERROR_MESSAGE:
      "That didn't work. Please try again.",
    ARTICLES_ARTICLE_VIEWER_FOLLOW: 'Follow',
    ARTICLES_ARTICLE_VIEWER_FOLLOWING: 'Following',
    ARTICLES_ARTICLE_VIEWER_FOLLOWING_CONTACTS_COUNT_PLURAL:
      '{count} of your contacts are following this Insider.',
    ARTICLES_ARTICLE_VIEWER_FOLLOWING_CONTACTS_COUNT_PLURAL_FEMALE:
      '{count} of your contacts are following this Insider.',
    ARTICLES_ARTICLE_VIEWER_FOLLOWING_CONTACTS_COUNT_PLURAL_MALE:
      '{count} of your contacts are following this Insider.',
    ARTICLES_ARTICLE_VIEWER_FOLLOWING_CONTACTS_COUNT_SINGULAR:
      '{count} of your contacts is following this Insider.',
    ARTICLES_ARTICLE_VIEWER_FOLLOWING_CONTACTS_COUNT_SINGULAR_FEMALE:
      '{count} of your contacts is following this Insider.',
    ARTICLES_ARTICLE_VIEWER_FOLLOWING_CONTACTS_COUNT_SINGULAR_MALE:
      '{count} of your contacts is following this Insider.',
    ARTICLES_ARTICLE_VIEWER_INSIDER_ARTICLE_PLURAL: 'articles',
    ARTICLES_ARTICLE_VIEWER_INSIDER_ARTICLE_SINGULAR: 'article',
    ARTICLES_ARTICLE_VIEWER_NOT_FOUND_MESSAGE:
      "Unfortunately this page isn't available right now.",
    ARTICLES_ARTICLE_VIEWER_PUBLISHED_AT: 'Published on {date}',
    ARTICLES_ARTICLE_VIEWER_READ_ARTICLE_ARIA_LABEL: 'read article {title}',
    ARTICLES_ARTICLE_VIEWER_TOP_BAR_TITLE: 'XING News',
    ARTICLES_ARTICLE_VIEWER_VIEW_ARTICLES_COLLECTION: 'View articles',
    ARTICLES_ARTICLE_VIEWER_VIEW_AS_VISITOR:
      'What your article looks like to visitors.',
    ARTICLES_ARTICLE_VIEWER_WRITES_ABOUT: '{title} writes about {tagline}',
    ARTICLES_PREMIUM_BANNER_BODY:
      'As a Premium member you get access to interesting articles, detailed background reports, and e-learning offers from selected publishers.',
    ARTICLES_PREMIUM_BANNER_BUTTON: 'Unlock Premium',
    ARTICLES_PREMIUM_BANNER_HEADLINE: 'News exclusive to Premium',
    ARTICLES_PROJOBS_BANNER_BODY:
      'With ProJobs you get access to interesting articles, detailed background reports, and e-learning offers from selected publishers.',
    ARTICLES_PROJOBS_BANNER_BUTTON: 'Unlock ProJobs',
    ARTICLES_PROJOBS_BANNER_HEADLINE: 'News exclusive to ProJobs',
    COMMBOX_AUDIENCE_HEADLINE: 'Who can see this?',
    COMMBOX_AUDIENCE_PRIVATE: 'Private (XING contacts only)',
    COMMBOX_AUDIENCE_PRIVATE_DESC: "Your post can't be shared.",
    COMMBOX_AUDIENCE_PUBLIC: 'Public',
    COMMBOX_AUDIENCE_PUBLIC_DESC: 'Anyone can see and share this.',
    CONTENT_VIDEO_ADD: 'Add video',
    CONTENT_VIDEO_ARTICLE_HEADLINE_PLACEHOLDER:
      'Add a title for your video here.',
    CONTENT_VIDEO_ARTICLE_VIDEO_ADDED: 'Video added',
    CONTENT_VIDEO_EDIT: 'Edit',
    CONTENT_VIDEO_ENTER_ID:
      "Sorry, we didn't recognise your ID. Please check it again.",
    CONTENT_VIDEO_FEATURE_OFF: 'Sorry, this video is currently unavailable. ',
    CONTENT_VIDEO_ID: 'Video ID',
    CONTENT_VIDEO_IN_PROGRESS: "Just a second. We're processing your video...",
    CONTENT_VIDEO_RECOS_REASON: 'Popular videos on XING',
    CONTENT_VIDEO_REMOVE: 'Remove',
    CONTENT_VIDEO_STATUS_NOT_FOUND: "Sorry, we couldn't find this video.",
    CONTENT_VIDEO_STATUS_UNKNOWN_ERROR:
      "Sorry, this video isn't available right now.",
    CONTENT_VIDEO_TRY_AGAIN: 'Something went wrong. Please try again.',
    CONTENT_VIDEO_TYPE:
      'Please select a video you want to add to this article.',
    PROGRESS_BAR_LOADING_PERCENTAGE: '{percentage}% finished',
    UPLOADER_ADD_IMAGE: 'Add image',
    UPLOADER_ADD_VIDEO: 'Add video',
    UPLOADER_CANCEL_UPLOAD: 'Cancel upload',
    UPLOADER_ERROR_BODY: 'Please try again.',
    UPLOADER_ERROR_HEADLINE: "Sorry, that didn't work.",
    UPLOADER_IMAGE_LOADING_HEADLINE: 'Uploading image...',
    UPLOADER_TRY_AGAIN: 'Try again',
    UPLOADER_VIDEO_LOADED_BODY:
      "We are now processing it to make sure it'll look great. This may take a few minutes – but don't let that keep you from posting or sharing it now.\n\n",
    UPLOADER_VIDEO_LOADED_HEADLINE: 'Your video has been uploaded.',
    UPLOADER_VIDEO_LOADING_HEADLINE: 'Uploading video...',
    VIDEO_DELETE_ERROR:
      "We couldn't delete your video just now. Please try again.",
    VIDEO_DIALOG_CANCEL: 'Cancel',
    VIDEO_DIALOG_CONFIRM: 'Discard',
    VIDEO_DIALOG_HEADLINE: 'Discard changes?',
    VIDEO_DIALOG_TEXT: "You won't be able to undo this.",
    VIDEO_ENCODING_HEADLINE: 'Encoding your video...',
    VIDEO_ENCODING_MESSAGE:
      'Please bear with us as this may take a few minutes.',
    VIDEO_SAVE_ERROR: "We couldn't save your video just now. Please try again.",
    VIDEO_UPLOAD_CANCEL: 'Discard',
    VIDEO_UPLOAD_CROP_CANCEL: 'Discard',
    VIDEO_UPLOAD_CROP_MAX: 'Max.',
    VIDEO_UPLOAD_CROP_MIN: 'Min.',
    VIDEO_UPLOAD_CROP_SAVE: 'Save',
    VIDEO_UPLOAD_DELETE: 'Delete video',
    VIDEO_UPLOAD_ENCODING_TITLE:
      "Your video is being prepared. We'll e-mail you to let you know when it’s ready.",
    VIDEO_UPLOAD_INPROGRESS_DESCRIPTION: '{percentage}% completed',
    VIDEO_UPLOAD_INPROGRESS_TITLE: 'Uploading your video...',
    VIDEO_UPLOAD_PREVIEW_IMAGE_CTA: 'Select image',
    VIDEO_UPLOAD_PREVIEW_IMAGE_DESCRIPTION:
      "You can add a custom preview image for your video here (JPG or PNG, max. 10MB). Otherwise we'll display a still image from the video.",
    VIDEO_UPLOAD_PREVIEW_IMAGE_TITLE: 'Preview image',
    VIDEO_UPLOAD_READY_CTA: 'Browse files',
    VIDEO_UPLOAD_READY_DESCRIPTION:
      'Format: AVI, MOV or MP4  | Ratio: 16:9 | Size: max. 5 GB',
    VIDEO_UPLOAD_READY_TITLE: 'Drag & drop or select a file.',
    VIDEO_UPLOAD_READY_TITLE_DRAGGING: 'Drop your file now',
    VIDEO_UPLOAD_SAVE: 'Save',
    VIDEO_UPLOAD_SUBTITLES_CTA: 'Choose file',
    VIDEO_UPLOAD_SUBTITLES_DESCRIPTION:
      'Here you can add subtitles to your video with a WebVTT or SRT file. ',
    VIDEO_UPLOAD_SUBTITLES_LABEL_DE: 'German',
    VIDEO_UPLOAD_SUBTITLES_LABEL_EN: 'English',
    VIDEO_UPLOAD_SUBTITLES_TITLE: 'Subtitles',
    VIDEO_UPLOAD_TITLE: 'Video title',
    VIDEO_UPLOADING_ERROR:
      "We couldn't upload your video. Please select a file in AVI, MOV or MP4 format in 16:9 ratio and up to 5 GB in size.",
    VIDEOS_AUTOPLAY: 'Autoplay',
    VIDEOS_SETTINGS: 'Autoplay videos?',
    VIDEOS_WATCH_VIDEO: 'Watch video',
    XWS_100_APP_PERMISSION_VENDOR_VIDEOS: 'Access XING videos vendor API',
    XWS_100_APP_PERMISSION_VENDOR_VIDEOS_HEADING: 'XING videos API',
  },
};
